module.exports = __webpack_public_path__ + "static/img/01.f585539.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news22/01.png
// module id = IlpC
// module chunks = 1